import React from 'react';
import clsx from 'clsx';

interface SessionStatusBadgeProps {
  status: 'ACTIVE' | 'ENDED';
  size?: 'sm' | 'md' | 'lg';
}

export const SessionStatusBadge: React.FC<SessionStatusBadgeProps> = ({ status, size = 'md' }) => {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base',
  };

  const statusConfig = {
    ACTIVE: {
      bg: 'bg-green-100',
      text: 'text-green-800',
      icon: '🟢',
      label: 'ACTIVE',
    },
    ENDED: {
      bg: 'bg-gray-100',
      text: 'text-gray-800',
      icon: '⚪',
      label: 'ENDED',
    },
  };

  const config = statusConfig[status];

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-full font-medium',
        config.bg,
        config.text,
        sizeClasses[size]
      )}
    >
      <span>{config.icon}</span>
      <span>{config.label}</span>
    </span>
  );
};
